import React from 'react';
import PropTypes from 'prop-types';
import { Markup } from 'interweave';
import Stat from '@strava/ui/Stat';
import Stats from '@strava/ui/Stats';
import { useLoggedOutAthletePageContext } from '../../../../state/LoggedOutAthletePageContext';

import styles from './ActivityStats.module.scss';

const ActivityStats = ({ activity }) => {
  const { t } = useLoggedOutAthletePageContext();

  const stats =
    activity.isManual || !activity.hasGps
      ? { time: activity.movingTime }
      : {
          distance: activity.distance,
          elevation: activity.elevation,
          time: activity.movingTime
        };

  return (
    <Stats listClassName={styles.listStats}>
      {Object.keys(stats).map((stat) => (
        <Stat
          label={t(stat)}
          value={<Markup noWrap={true} content={stats[stat]} />}
          valueClassName={styles.statValue}
          key={stat}
        />
      ))}
    </Stats>
  );
};

ActivityStats.propTypes = {
  activity: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    type: PropTypes.string,
    detailedType: PropTypes.string,
    startDateLocal: PropTypes.string,
    distance: PropTypes.string,
    elevation: PropTypes.string,
    movingTime: PropTypes.string,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.string,
        primary: PropTypes.bool,
        caption: PropTypes.string,
        defaultSrc: PropTypes.string,
        squareSrc: PropTypes.string
      })
    ),
    isManual: PropTypes.bool,
    hasGps: PropTypes.bool
  }).isRequired
};

export default ActivityStats;
